<template>

    <div class="v-application v-application--is-ltr theme--light">

        <v-card elevation="24">

            <v-card-title class="text-h6">
                {{ title || 'Update' }}
            </v-card-title>

            <v-card-text v-if="message">
                {{ message || 'Are you sure that you would like to perform this action?' }}
            </v-card-text>

            <div class="modal-create-data-section edit-date-input-section">
                <div class="modal-create-data-item">
                    <p>First Name*</p>
                    <input ref="firstName" class="visitor-modal-title" v-model="firstName" />
                </div>
                <div class="modal-create-data-item" style="margin-top: 8px;">
                    <p>Last Name*</p>
                    <input ref="lastName" class="visitor-modal-title" v-model="lastName" />
                </div>
                <div ref="email" class="modal-create-data-item" style="margin-top: 8px;">
                    <p>Email</p>
                    <input class="visitor-modal-title" v-model="email" />
                </div>
                <div ref="phoneNumber" class="modal-create-data-item" style="margin-top: 8px;">
                    <p>Phone Number*</p>
                    <input class="visitor-modal-title" v-model="phoneNumber" />
                </div>
                <div ref="relationship" class="modal-create-data-item" style="margin-top: 8px;">
                    <p>Relationship*</p>
                    <input class="visitor-modal-title" v-model="relationship" />
                </div>
            </div>

            <v-card-text v-if="disclaimer" style="color: black; padding-top: 0px;">
                {{ disclaimer || 'By selecting Confirm, you are authorizing this action to be taken' }}
            </v-card-text>

            <v-card-actions>
                <v-btn color="primary" @click="confirm">
                    {{ confirmText || 'Confirm' }}
                </v-btn>
                <v-btn color="red" text @click="close">
                    {{ cancelText || 'Cancel' }}
                </v-btn>
            </v-card-actions>

        </v-card>

    </div>

</template>

<script>
import * as Utils from '../../../js/Utils'
export default {
    props: ["title", "message", "disclaimer", "cancelText", "confirmText", "onConfirm"],
    data() {
        return {
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            relationship: "",
        }

    },
    computed: {

    },
    watch: {
        phoneNumber(newVal) {
            if (Utils.isValidPhoneNumber(newVal)) {
                this.$refs['phoneNumber'].classList.remove('invalid')
            } else {
                this.$refs['phoneNumber'].classList.add('invalid')
            }
        },
        firstName(newVal) {
            if (newVal.length > 0) {
                this.$refs['firstName'].classList.remove('invalid')
            } else {
                this.$refs['firstName'].classList.add('invalid')
            }
        },
        lastName(newVal) {
            if (newVal.length > 0) {
                this.$refs['lastName'].classList.remove('invalid')
            } else {
                this.$refs['lastName'].classList.add('invalid')
            }
        },
        relationship(newVal) {
            if (newVal.length > 0) {
                this.$refs['relationship'].classList.remove('invalid')
            } else {
                this.$refs['relationship'].classList.add('invalid')
            }
        }
    },
    methods: {

        close() {
            this.$emit('close');
        },
        validateInputs() {
            let missingData = []
            // First Name
            if (this.firstName.length == 0) {
                missingData.push("Please Enter a First Name")
            }
            // Last Name
            if (this.lastName.length == 0) {
                missingData.push("Please Enter a Last Name")
            }
            // Phone
            if (!Utils.isValidPhoneNumber(this.phoneNumber)) {
                missingData.push("Phone Number is incorrectly formatted, please format as +19991234567")
            }
            // Relationship
            if (this.relationship.length == 0) {
                missingData.push("Please Enter a Relationship")
            }
            if (missingData.length > 0) {
                alert(missingData.join('\n'))
                return false
            } else {
                return true
            }
        },
        async confirm() {
            if (!this.validateInputs()) {
                return;
            }
            if (!this.onConfirm) {
                this.close();
                return;
            }

            const constructedData = {
                "contact_first_name": this.firstName,
                "contact_last_name": this.lastName,
                "contact_email": this.email,
                "contact_phone_number": this.phoneNumber,
                "contact_relationship": this.relationship,
                "current_status": "ACTIVE"
            }
            await this.onConfirm(constructedData);
            this.close();
        }
    }

};
</script>

<style scoped>
.vuetify-modal-wrapper {
    background: transparent;
}

.edit-date-input-section {
    padding-left: 1em;
    padding-right: 1em;
    padding-bottom: 1em;
}
</style>